import Localizer from 'thdlocalizer';

define(
  ['knockout', 'jquery'],
  function (ko, $) {

    var integrationConfig = {};

    var isNumber = function (value) {
      return !isNaN(value) &&
        isFinite(value) &&
        Math.floor(value) === value;
    };

    var getCookie = function (name) {
      var cookieName = name + "=";

      var cookieCollection = document.cookie.split(';');

      for (var i = 0; i < cookieCollection.length; i++) {
        var cookie = cookieCollection[i];
        if (cookie.lastIndexOf(cookieName) > -1)
          return cookie.replace(cookieName, "").trim();
      }

      return null;
    };

    var getValueFromCookie = function (key) {
      var content = getCookie(integrationConfig.cookie);

      if (content !== null && content !== "" && isNumber(+content))
        return content;

      return "";
    }

    var getStoreFromLocalizer = () => {
      const localStore = Localizer.getLocalizedStore();
      const defaultStore = {
        storeId: 121,
        storeFullName: 'Cumberland - Atlanta, GA',
        storeName: 'Cumberland',
        zipcode: '30339',
      }

      return localStore === null || localStore === undefined ? defaultStore : localStore;
    }

    var getZipcodeFromCookie = function () {
      return getValueFromCookie('C24');
    };

    function ViewModel(baseUrl, stacked, isProfessionallyInstallable) {
      var self = this;
      self.displayModal = ko.observable(false);
      self.availableInArea = ko.observable(false);
      // https://www.pivotaltracker.com/story/show/160360337
      self.installStartingPrice = ko.observable(99);
      self.componentElement = undefined;

      this.shouldDisplayStacked = ko.computed(function () {
        //the item can come back as an array per Thang.
        if (stacked)
          return true;
        if ((self.componentElement === undefined) || (self.componentElement && self.componentElement.length == 0)) {
          var selector = document.getElementsByClassName("measure-and-install");

          if (selector == null) {
            return false;
          } else if (selector.length > 0) {
            self.componentElement = selector[0];
          } else {
            self.componentElement = selector;
          }
        }

        if ((Object.keys(self.componentElement).length === 0 && self.componentElement.constructor === Object) ||
          (self.componentElement && self.componentElement.length == 0)) {
          return false;
        }

        // get the width
        var data = self.componentElement.getBoundingClientRect();

        return data.width < 400;
      });

      this.showModal = function () {
        self.displayModal(true);
      }

      this.closeModal = function () {
        self.displayModal(false);
      }

      this.startProcess = function () {
        window.location.href = integrationConfig.baseUrl + 'schedule?ismobile=false';
      }

      this.goToMWT = function () {
        window.location.href = integrationConfig.baseUrl + 'mywindowtreatments';
      }

      if (!isProfessionallyInstallable) return;

      //verify availability
      try {
        //for some reason these are not always on the page any more.
        integrationConfig.baseUrl = baseUrl;
        integrationConfig.cookie = "THD-LOC-STORE"; //document.getElementById("m_icookieStore").value;

        var store = getStoreFromLocalizer();
        var zipcode = getZipcodeFromCookie() || "30339";

        // TODO: hardcoded servicetype to 1 = measure
        var queryString = 'api/service-providers/check-store-availability?storeNumber=' + store.storeId + '&service=1';

        $.ajax({
          url: integrationConfig.baseUrl + queryString,
          type: "GET"
        })
          .done(function (response) {
            $.ajax({
              url: integrationConfig.baseUrl + 'api/pricing/bands?zipcode=' + zipcode + '&serviceType=2',
              type: 'GET'
            })
              .done(function (pricingResponse) {
                if (pricingResponse.statusCode === 200) {
                  var specs = pricingResponse.result;
                  var installSpec = specs.filter(function (spec) { return spec.specId === 'installation' });
                  if (installSpec && installSpec[0].pricingBands && installSpec[0].pricingBands[0]) {
                    self.installStartingPrice(installSpec[0].pricingBands[0].basePrice);
                  }
                }
              })
              .complete(function () {
                self.availableInArea(response.statusCode === 200 && response.result);
              })
          });

      } catch (e) {
        //ignore life.
      }
    }

    return ViewModel;
  }
);
